/**
 * Third-party assets, shown in Help: those under CC BY 4.0 ask for it; the Sketchfab Free
 * Standard ones do not, but are listed all the same. Keep in step with docs/CREDITS.md.
 */
export interface Credit {
  title: string;
  author: string;
  url: string;
  license: string;
}

export const CREDITS: readonly Credit[] = [
  {
    title: 'Airbus A320 Airliner',
    author: 'Kyaie',
    url: 'https://sketchfab.com/models/757aa190f27a407291187328d7125903',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low Poly Boeing 787 Dreamliner',
    author: 'maurogsw',
    url: 'https://sketchfab.com/models/50baa323fabd49a6b861096cb88e5c25',
    license: 'CC BY 4.0',
  },
  {
    title: 'Boeing 747-830İ Lufthansa 100th Year',
    author: 'nobilishornet2',
    url: 'https://sketchfab.com/models/df2aa3fd3af94f55af798816c3a0f0ae',
    license: 'CC BY 4.0',
  },
  {
    title: 'Antonov An-124',
    author: 'ArtBlender',
    url: 'https://sketchfab.com/models/70bc72ce8ec2421f9b7ec004d1ec7c7b',
    license: 'CC BY 4.0',
  },
  {
    title: 'Cessna 172Kr (with cockpit) (ver III)',
    author: 'TonyWony',
    url: 'https://sketchfab.com/models/e104f0a64da5499d9b8b9d60dc896cf8',
    license: 'CC BY 4.0',
  },
  {
    title: '737 MAX Lion Air',
    author: 'sofyankurniawan',
    url: 'https://sketchfab.com/models/2747cad8b4c64122abe992c9ad1e8bd1',
    license: 'CC BY 4.0',
  },
  {
    title: 'boeing 777 aeroflot',
    author: 'tnikita',
    url: 'https://sketchfab.com/models/32c3ca1705bc4c05b5ea3b9052241491',
    license: 'CC BY 4.0',
  },
  {
    title: 'ATR 72 - 600',
    author: 'sofyankurniawan',
    url: 'https://sketchfab.com/models/1e1a7186f7444d288675262fcee44744',
    license: 'CC BY 4.0',
  },
  {
    title: 'Airbus A220 / Bombardier CS300',
    author: 'your_average_waifu',
    url: 'https://sketchfab.com/models/8a4876f00c5f461c8ad1c35351ec9588',
    license: 'CC BY 4.0',
  },
  {
    title: 'Delta Airlines Airbus A350-900',
    author: 'Tyler_Dave',
    url: 'https://sketchfab.com/models/b108d460122f4113960e000fc6f2ad44',
    license: 'CC BY 4.0',
  },
  {
    title: 'Bombardier Dash Q400 - Qantas Link',
    author: 'sofyankurniawan',
    url: 'https://sketchfab.com/models/5b13a73be7d74161a3a9f9ce982a8345',
    license: 'CC BY 4.0',
  },
  {
    title: 'Airbus A380 - 800',
    author: 'nobilishornet2',
    url: 'https://sketchfab.com/models/cfd1092a207b4085a32fbb89c6b32f25',
    license: 'CC BY 4.0',
  },
  {
    title: 'Bombardier Learjet 45',
    author: 'rammgraffic',
    url: 'https://sketchfab.com/models/0a47767ccd084aef98b1a0f9210c433e',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low Poly Helicopter',
    author: 'antonmoek',
    url: 'https://sketchfab.com/models/5bbed2de9baa4a13a7faa72653b78b64',
    license: 'CC BY 4.0',
  },
  {
    title: 'Cedric-ec135-_waving-190_rotor',
    author: 'TG13730',
    url: 'https://sketchfab.com/models/815e8d7a415345ccb40de9abf8426588',
    license: 'CC BY 4.0',
  },
  {
    title: 'MD-500 Defender Helicopter',
    author: 'duanesmind',
    url: 'https://sketchfab.com/models/da5daae0fe354269895b58c2ed72e2b8',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low Poly Bombardier CR7 airplane',
    author: 'symetrik_games',
    url: 'https://sketchfab.com/models/09bca6605a8f4717b9c724be54aeef92',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low-Poly Gulfstream Aircraft',
    author: 'maurogsw',
    url: 'https://sketchfab.com/models/af86c5f4a3054cd8a30d1ad213f99e57',
    license: 'CC BY 4.0',
  },
  {
    title: 'F-16 Fighter Jet',
    author: 'iedalton',
    url: 'https://sketchfab.com/models/d84491f443384ee488593cc6f0f0839e',
    license: 'CC BY 4.0',
  },
  {
    title: 'C-130J',
    author: 'sofyankurniawan',
    url: 'https://sketchfab.com/models/0ec8ffc5fa684077b3238a8c1dc77927',
    license: 'CC BY 4.0',
  },
  {
    title: 'Baykar Bayraktar TB2',
    author: 'TheDevilsEye',
    url: 'https://sketchfab.com/models/8e5b6972f7d049f19688096e03949487',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low Poly Humvee vehicle',
    author: 'duanesmind',
    url: 'https://sketchfab.com/models/fac4178dc3db4eb9abf7f45425125e1e',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low-poly Military Truck 2k by Jungle Jim',
    author: 'jungle_jim',
    url: 'https://sketchfab.com/models/87141126703d42a69a9e73f2673fdb1a',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low poly Flakpanzer gepard',
    author: 'S1Priv',
    url: 'https://sketchfab.com/models/43d276c929184ad6822d9b868e1dbd26',
    license: 'CC BY 4.0',
  },
  {
    title: 'RLS P-35',
    author: 'manyakasia',
    url: 'https://sketchfab.com/models/7cabcbaabd5045309532876d8e53804c',
    license: 'CC BY 4.0',
  },
  {
    title: 'Nasams 1 Surface-to-Air Missile System',
    author: 'MirzaArrafiERV_45',
    url: 'https://sketchfab.com/models/5fb34fab137c430988fd5642a3b87db3',
    license: 'CC BY 4.0',
  },
  {
    title: 'MIM-104 Patriot Air Defense System',
    author: 'MirzaArrafiERV_45',
    url: 'https://sketchfab.com/models/95e1e402426f4ddcb543af7a0455cf05',
    license: 'CC BY 4.0',
  },
  {
    title: 'Renault TRM Radar Truck',
    author: 'MirzaArrafiERV_45',
    url: 'https://sketchfab.com/models/1ad95e5724624a3bba7d36a686817efc',
    license: 'CC BY 4.0',
  },
  {
    title: 'Generic passenger car pack',
    author: 'comrade1280',
    url: 'https://sketchfab.com/models/20f9af9b8a404d5cb022ac6fe87f21f5',
    license: 'CC BY 4.0',
  },
  {
    title: 'Generic civil service vehicles pack',
    author: 'comrade1280',
    url: 'https://sketchfab.com/models/8ff2a13f30914932a70c7950cfa58465',
    license: 'CC BY 4.0',
  },
  {
    title: 'Tata Signa Cargo Truck | Low Poly Game Ready',
    author: 'kevin_k_5124',
    url: 'https://sketchfab.com/models/a5c03c1a1c2c4b21b7db6192b1ef8718',
    license: 'CC BY 4.0',
  },
  {
    title: 'Airport Pack Total',
    author: 'assetfactory',
    url: 'https://sketchfab.com/models/ad40f27ecd5e492c8149cde6a5dd56d1',
    license: 'Sketchfab Free Standard',
  },
  {
    title: 'Airport Catering Truck',
    author: 'rwy00',
    url: 'https://sketchfab.com/models/289f4e2cfa3f4722b0476b1fc37681d8',
    license: 'CC BY 4.0',
  },
  {
    title: 'Low poly belt loader',
    author: 'beli.estefano',
    url: 'https://sketchfab.com/models/e00484568f4245cdb824e4d4e0cc95e5',
    license: 'CC BY 4.0',
  },
  {
    title: 'Airport Fuel Truck',
    author: 'nguyentuannghia17a',
    url: 'https://sketchfab.com/models/15a96ac34ece464480a9b8620dc3a3d3',
    license: 'CC BY 4.0',
  },
  {
    title: 'GPU (Aiport Ground Power Unit)',
    author: 'omri_ha_muglob',
    url: 'https://sketchfab.com/models/b18e62dda2e04e97a95312bb6a284f1c',
    license: 'CC BY 4.0',
  },
  {
    title: 'Aircraft_Tug',
    author: 'Chukk007',
    url: 'https://sketchfab.com/models/ac1c0a974a734864a27fe84dbbcb0de8',
    license: 'CC BY 4.0',
  },
  {
    title: 'Airport Stairs',
    author: 'assetfactory',
    url: 'https://sketchfab.com/models/424b5d3ae1b64126971650567449660c',
    license: 'Sketchfab Free Standard',
  },
  {
    title: 'Lockheed Martin F-35B Lightning II',
    author: 'jsong.js.us',
    url: 'https://sketchfab.com/models/5d54a6af45974ad386ae74d42b33374a',
    license: 'CC BY 4.0',
  },
  {
    title: 'Lockheed Martin F-22 "Raptor"',
    author: 'andertan',
    url: 'https://sketchfab.com/models/7e7b3c372e374dda98e70208d09cfdcf',
    license: 'CC BY 4.0',
  },
  {
    title: 'Jet Plane Flyby (sound)',
    author: 'qubodup',
    url: 'https://freesound.org/people/qubodup/sounds/189446/',
    license: 'CC0',
  },
  {
    title: 'Sonic Boom (sound)',
    author: 'qubodup',
    url: 'https://freesound.org/people/qubodup/sounds/182050/',
    license: 'CC0',
  },
];
